(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/campaign-ui/views/campaign-card.js') >= 0) return;  svs.modules.push('/components/numbergames/campaign-ui/views/campaign-card.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.numbergames=_svs.numbergames||{};
_svs.numbergames.campaign_ui=_svs.numbergames.campaign_ui||{};
_svs.numbergames.campaign_ui.templates=_svs.numbergames.campaign_ui.templates||{};
svs.numbergames.campaign_ui.templates.campaign_card = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression((lookupProperty(helpers,"numbergames")||(depth0 && lookupProperty(depth0,"numbergames"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"campaign_ui/campaign-card",depth0,{"name":"numbergames","hash":{},"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":1,"column":45}}}))
    + "\n";
},"useData":true});
Handlebars.partials['components-numbergames-campaign_ui-campaign_card'] = svs.numbergames.campaign_ui.templates.campaign_card;
})(svs, Handlebars);


 })(window);